// extracted by mini-css-extract-plugin
export default {"container":"DistrictManagement_container__jaXGB"};